import { render, staticRenderFns } from "./InnovativeProduct.vue?vue&type=template&id=31c202e8&scoped=true"
import script from "./InnovativeProduct.vue?vue&type=script&lang=js"
export * from "./InnovativeProduct.vue?vue&type=script&lang=js"
import style0 from "./InnovativeProduct.vue?vue&type=style&index=0&id=31c202e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c202e8",
  null
  
)

export default component.exports